
import { defineComponent, ref } from "vue";
import StatusBlock from "./StatusBlock.vue";
import LoadingModal from "./LoadingModal.vue";
import LoginFormContainer from "./LoginFormContainer.vue";
import RecaptchaBlock from "./RecaptchaBlock.vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import { useRouter } from "vue-router";
import { States, submitHandler } from "./submit_handler";
import { useUserStore } from "@/store/user";
import { useConfigStore } from "@/store/config";
import { useAuthStore } from "@/store/auth";

export default defineComponent({
  components: {
    LoginFormContainer,
    StatusBlock,
    LoadingModal,
    Form,
    Field,
    ErrorMessage,
    RecaptchaBlock,
  },
  setup() {
    const config = useConfigStore();
    const user = useUserStore();
    const auth = useAuthStore();
    let router = useRouter();
    let states: States = {
      recaptcha: ref(null),
      loadingShow: ref(false),
      errorMessage: ref(""),
      captchaEnabled: config.captcha.validateCaptchaForSmsCode,
    };
    let smsCode = ref("");

    function resendSms() {
      submitHandler(user.resendSMS(), states);
    }

    function checkSmsCode() {
      submitHandler(user.phoneCode({ code: smsCode.value }), states, () => {
        router.push("agreement");
      });
    }

    function editPhone() {
      submitHandler(user.editPhone(), states, () => {
        router.push("phone-enter");
      });
    }

    function logout() {
      auth.logout();
    }

    return {
      loadingShow: states.loadingShow,
      captchaEnabled: states.captchaEnabled,
      errorMessage: states.errorMessage,
      recaptcha: states.recaptcha,
      smsCode,
      resendSms,
      checkSmsCode,
      editPhone,
      logout,
      user,
    };
  },
});
